import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Message } from '../../_models';
import { DocumentoService } from 'src/app/_services/documento.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-popup-messages-new-styles-test',
  templateUrl: './popup-messages-new-style-test.component.html',
  styleUrls: ['./popup-messages-new-style-test.component.css']
})
export class PopupMessagesNewStyleTestComponent implements OnInit {
  textButton: string;
  confirm: boolean;
  downloadSavePrint;
  type: string;
  htmlStr: string;
  iconType : string;

  @ViewChild('mensagensContainer') mensagensContainer!: ElementRef;

  constructor(
    private documentoService: DocumentoService,
    private dialogRef: MatDialogRef<PopupMessagesNewStyleTestComponent>,
    private snackBar: MatSnackBar, 
    @Inject(MAT_DIALOG_DATA) public data: Message) { }

  ngOnInit() {
    this.getIcone();

    if (this.data.type === 'confirm') {
      this.confirm = true;
      this.textButton = 'SIM';
    } else {
      this.confirm = false;
      this.textButton = 'OK';
    }

    if (this.data.message.indexOf('tente salvá-lo no modo impressão') !== -1) {
      this.downloadSavePrint = true;
    } else {
      this.downloadSavePrint = false;
    }

    this.type = this.type = 'application/pdf';

    this.htmlStr = this.data.message;
  }

  getSavePrint() {
    this.documentoService.getSavePrint().subscribe(respData => {
      this.downLoadFile(respData, this.type);
    }, error => {

    });
  }

  downLoadFile(data: any, type: string) {
    let blob = new Blob([data], { type: type.toString() });
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed === 'undefined') {
      alert('Desative o bloqueador de pop-ups e tente novamente.');
    }
  }

  Confirm() {
    this.dialogRef.close(true);
  }

  closePopup() {
    this.dialogRef.close(false);
  }

  notConfirm() {
    this.dialogRef.close(false);
  }

  getIcone(): string {
    switch (this.data.type) {
      case 'warning':
        return 'warning_amber';
      case 'cancel':
        return 'close';
      case 'error':
        return 'error_outline';
      case 'confirm':
        return 'help_outline';  
      case 'success':
        return 'check_circle_outline';  
      case 'alert':
        return 'notification_important';  

      default:
        return 'help_outline'; // Ícone padrão
    }
  }
  
  copiarConteudo() {
    
    const html = this.mensagensContainer?.nativeElement?.innerHTML || '';
    const texto = html
      .replace(/<br\s*[\/]?>/gi, "\n")
      .replace(/<\/?[^>]+(>|$)/g, '')
      .trim();

    navigator.clipboard.writeText(texto)
      .then(() => {
        this.snackBar.open('Conteúdo copiado com sucesso!', '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: ['success-snackbar']
        });
      })
      .catch(err => {
        console.error('Erro ao copiar: ', err);
        this.snackBar.open('Erro ao copiar conteúdo', '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: ['error-snackbar']
        });
      });
  }

  temLinhasSuficientes(): boolean {
    
    const html = this.mensagensContainer?.nativeElement?.innerHTML || '';
    const textoFormatado = html
      .replace(/<br\s*[\/]?>/gi, "\n")
      .replace(/<\/?[^>]+(>|$)/g, '')
      .trim();
      
    const linhasTexto = textoFormatado.split('\n').filter(l => l.trim() !== '');
    return linhasTexto.length >= 5;
  }

  isMensagemErro(): boolean {
    return !this.confirm;
  }
  }
